import { JuloUpdateEntry } from "./types"

export const kommentarshistorikTillaggsorderEntry: JuloUpdateEntry = {
  slug: "2026-06-12-kommentarshistorik-tillaggsorder",
  date: "2026-06-12",
  title: "Kommentarshistorik även i tilläggsordrar",
  description:
    "Historikknappen i kommentarsfältet finns nu också på komponentåtgärder i tilläggsordrar, precis som i besiktningsprotokollet. Klicka på den så ser ni kommentarer som er verkstad tidigare har skrivit för samma komponent, och klicka på en kommentar för att fylla i den direkt. Historiken är dessutom delad: kommentarer från tilläggsordrar dyker upp i besiktningsprotokollet och tvärtom, så ni kan återanvända era formuleringar oavsett var de skrevs.",
  images: [
    {
      src: "/julo-updates/2026-06-12-kommentarshistorik-tillaggsorder/kommentarshistorik-tillaggsorder.png",
      alt: 'Komponentåtgärden Byt kedja i en tilläggsorder med kommentarshistoriken öppen under kommentarsfältet: överst filterknappen Enbart för byt, därunder tidigare kommentarer som "Sliten, bör verkligen bytas." med byt-ikonen framför varje rad.',
    },
  ],
}
